export default __webpack_public_path__ + "static/media/app7-woman.95c0b96f.png";